var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.5C0 6.70435 0.316071 5.94129 0.87868 5.37868C1.44129 4.81607 2.20435 4.5 3 4.5H14.25C14.9776 4.49991 15.6805 4.76429 16.2277 5.24389C16.7749 5.72349 17.1292 6.38563 17.2245 7.107L21.8895 5.034C22.1178 4.93226 22.368 4.8892 22.6172 4.90873C22.8664 4.92826 23.1068 5.00977 23.3165 5.14584C23.5262 5.28192 23.6986 5.46824 23.8179 5.68789C23.9373 5.90753 23.9999 6.15352 24 6.4035V17.5965C23.9998 17.8463 23.9372 18.0921 23.8179 18.3115C23.6986 18.531 23.5264 18.7172 23.3169 18.8532C23.1074 18.9893 22.8673 19.0708 22.6183 19.0905C22.3693 19.1102 22.1193 19.0674 21.891 18.966L17.2245 16.893C17.1292 17.6144 16.7749 18.2765 16.2277 18.7561C15.6805 19.2357 14.9776 19.5001 14.25 19.5H3C2.20435 19.5 1.44129 19.1839 0.87868 18.6213C0.316071 18.0587 0 17.2956 0 16.5V7.5ZM17.25 15.2625L22.5 17.5965V6.4035L17.25 8.7375V15.2625ZM3 6C2.60218 6 2.22064 6.15804 1.93934 6.43934C1.65804 6.72064 1.5 7.10218 1.5 7.5V16.5C1.5 16.8978 1.65804 17.2794 1.93934 17.5607C2.22064 17.842 2.60218 18 3 18H14.25C14.6478 18 15.0294 17.842 15.3107 17.5607C15.592 17.2794 15.75 16.8978 15.75 16.5V7.5C15.75 7.10218 15.592 6.72064 15.3107 6.43934C15.0294 6.15804 14.6478 6 14.25 6H3Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraVideo);
export default __webpack_public_path__ + "static/media/CameraVideo.3906f2ed9851fda18696d9a2e7f4c456.svg";
export { ForwardRef as ReactComponent };